export default function SistemaContextoHolder () {
  let value = undefined;

  function get() {
    return value ? value.id : undefined;
  }

  function getObject() {
    return value;
  }

  function put(key, obj) {
    value = obj.value;
  }

  function getRegion() {
    return undefined;
  }

  function remove() {
    value = undefined;
  }

  return {
    get: get,
    getObject: getObject,
    put: put,
    getRegion: getRegion,
    remove: remove
  };
}
